import { types, flow, getEnv, getRoot } from 'mobx-state-tree'

import { BalanceRecord } from './'

const BalanceRecords = types
  .model('BalanceRecordsModel', {
    items: types.optional(types.map(BalanceRecord), {}),
  })
  .actions((self) => {
    const {
      service: { paymentService },
    } = getEnv(self)
    const root = getRoot(self)

    return {
      add(record) {
        if (!record) {
          return null
        }

        const trigger = record.tiggerDTO

        self.items.set(record.id, {
          ...record,
          trigger: trigger.id,
        })

        root.triggers.add(trigger)

        return self.items.get(record?.id)
      },

      load: flow(function* (params) {
        const response = yield paymentService.queryBalanceHistory(params)
        const balanceRecords = response.content.map((record) =>
          self.add(record)
        )

        return {
          response,
          balanceRecords,
        }
      }),
    }
  })

export const BalanceRecordsRoot = types.model('BalanceRecordsRoot', {
  balanceRecords: types.optional(BalanceRecords, {}),
})
